<ng-container *ngIf="showLoginForm && !isLoggedIn; else appContent">
  <app-login-form (loginSuccess)="onLoginSuccess()"></app-login-form>
</ng-container>

<ng-template #appContent>
  <router-outlet></router-outlet>
</ng-template>